import {HttpAxiosRequest} from "../httpAxiosBase";
import {Bank} from "../../types/generalData";

export const HttpCacheGeneral = {
    getEndpoint: (url: string): string => `cache/general${url}`,

    getBanks: (): Promise<Bank[]> => {
        return HttpAxiosRequest.get(
            HttpCacheGeneral.getEndpoint(`/bancos`)
        );
    },
}